const STORAGE_KEY = 'fl-wishlist';

function readWishlist() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (error) {
    return [];
  }
}

function writeWishlist(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

function syncButton(button) {
  const ids = readWishlist();
  const isSaved = ids.includes(button.dataset.productId);
  button.setAttribute('aria-pressed', String(isSaved));
}

document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-toggle]');
  if (!button) return;

  const id = button.dataset.productId;
  const ids = readWishlist();
  const index = ids.indexOf(id);

  if (index > -1) {
    ids.splice(index, 1);
  } else {
    ids.push(id);
  }

  writeWishlist(ids);
  syncButton(button);
});
